// @flow

import React, { useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import { Button } from "@components";
import type { DynamicQuestionContent } from "@modules/service/reducer/dynamic-questions/types";
import type { StepProps } from "@components";
import AnswerOptionsForm from "../dynamic-question-answer-options/answer-options-form";
import { split } from "@transformers/schema";

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  schema: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export function AnswerOptions(props: Props) {
  const [data, setData] = useState(props?.draft?.selectableValues);

  const answerOptionsSchema = split(props.schema, ["selectableValues"]);

  function handleSubmittedAnswerOptionsForm(data: Array<string>) {}

  function handleAnswerChange(props) {
    setData(props);
  }
  function handleAnswerSubmit() {
    if (data) {
      const updatedDraft = { ...props.draft, selectableValues: data };
      props.onUpdateDraft(updatedDraft);
      if (props.handleSubmit) {
        props.handleSubmit(updatedDraft, true);
      }
    }
  }

  if (!props.editable) {
    return null;
  }
  return (
    <React.Fragment>
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          <AnswerOptionsForm
            data={data}
            schema={answerOptionsSchema}
            onChange={handleAnswerChange}
          />
        </div>
      </div>
      <div className="w-100 d-flex justify-content-end mt-5 mb-3">
        <Button materialIcon="fast_forward" onClick={handleAnswerSubmit}>
          {props.t("NEXT")}
        </Button>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(AnswerOptions);
